import React from 'react';
import {
  ContentSubmission,
  ContentSubmissionVersion,
} from '@/types/contentSubmission';
import OffPlatformActivityFeed from './OffPlatformActivityFeed';
import OnPlatformActivityFeed from './OnPlatformActivityFeed';

export interface ContentSubmissionActivityFeedProps {
  testID?: string;
  version: ContentSubmissionVersion;
  contentSubmission: ContentSubmission;
  isOffPlatform: boolean;
  onCommentSubmit?: () => void;
  onActivityTabChange?: (tab: string) => void;
}

function ContentSubmissionActivityFeed({
  isOffPlatform,
  onCommentSubmit,
  onActivityTabChange,
  ...props
}: ContentSubmissionActivityFeedProps) {
  return isOffPlatform ? (
    <OffPlatformActivityFeed {...props} />
  ) : (
    <OnPlatformActivityFeed
      {...props}
      onCommentSubmit={onCommentSubmit}
      onActivityTabChange={onActivityTabChange}
    />
  );
}

export default ContentSubmissionActivityFeed;
